import { useMemo } from 'react'

import { AgChartProps } from 'ag-charts-react'
import { parse } from 'date-fns'

import { CustomAgChart } from '@fortem-monorepo/react-ag'
import { ICReport } from '@fortem-monorepo/web-sdk'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { commodities } from '@/react-query/queries/ic-report/hooks'

type DataKey = keyof ICReport.GetCommodityCurvesData[number]

export interface CommodityCrudeOilChartProps extends ICReportChartPrimitive {}

export const CommodityNatGasChart: React.FC<CommodityCrudeOilChartProps> = ({
  params,
  options,
}) => {
  const query = commodities.useCurves(params)
  const data = query.data ?? []

  const formattedData = useMemo(() => {
    return data.map((item) => {
      return {
        ...item,
        index: new Date(parse(item.index, 'LLL yy', new Date())),
      }
    })
  }, [data])

  const mergedOptions: AgChartProps['options'] = {
    title: {
      text: 'Natural Gas',
    },
    series: [
      {
        type: 'line',
        xKey: 'index',
        yKey: 'Natural Gas' satisfies DataKey,
        interpolation: { type: 'smooth' },
        data: formattedData,
        marker: {
          size: 0,
        },
        showInLegend: false,
      },
      {
        data: formattedData,
        type: 'bar',
        xKey: 'index',
        yKey: 'Natural Gas Exposure' satisfies DataKey,
        showInLegend: false,
      },
    ],
    axes: [
      {
        type: 'unit-time',
        parentLevel: {
          enabled: true,
        },
        position: 'bottom',
        label: {
          format: '%b %y',
        },
      },
      {
        type: 'number',
        position: 'left',
        keys: ['Natural Gas'] satisfies DataKey[],
      },
      {
        type: 'number',
        position: 'right',
        keys: ['Natural Gas Exposure'] satisfies DataKey[],
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
